import Vue from 'vue'
import Vuex from 'vuex'
import zebuLogo from '../assets/images/brokerIcon.png'
import service from '../store/httpService'
import router from '@/router'
import commonFunc from '../mixins/commonFunctions'
import orderWindow from './modules/orderWindow'

// modules
import scripInfo from './modules/scripInfo.js'
import uploadFile from './modules/fileUpload.js'
import cMaster from './modules/contractMaster.js'
import sector from './modules/sector.js'
import event from './modules/event.js'
import result from './modules/result.js'
import news from './modules/news.js'
import logs from './modules/logsData.js'
import apiKey from './modules/apikey.js'
import mpin from './modules/mpin.js'
import payment from './modules/paymentInfo.js'
import edisdata from './modules/edisfile.js'
import query from './modules/query.js'
import mostActive from './modules/mostActive.js'
import auth from './modules/ssoLogin.js'
import adminMessage from './modules/adminMessage'
import bankdetails from '../store/modules/bankdetails'
import mobileVersion from './modules/mobileVersion'
import orderCount from './modules/orderCount.js'
// const aliceblueLogo = `https://a3.aliceblueonline.com/img/loginLogo.cedcf4ac.png`
const aliceblueLogo = `https://aliceblueonline.com/assets/favicon.png`
const abmlLogo = require('../assets/images/abmlLogo.svg')
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    buildVersion: 'build_02_04_24_18_55',
    brokerName: 'ABML',
    brokerLogo: abmlLogo,
    loader: false,
    loginDetails: {},
    userLoginDetails: [],
    userBasedLogs: [],
    urlBasedLogs: [],
    snackbar: {
      show: false,
      msg: '',
      color: '',
      timeout: 2000
    },
    isMobileView: false,
    holidays: [],
    search: '',

    // chart objects
    USERLOGSCHARTDATA: {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
        backgroundColor: '#c7cfd9',
        textStyle: {
          "color": "#000"
        }
      },
      legend: {
        data: ["Mobile", "Web", "API", "Total"],
        bottom: 10,
        textStyle: {
          "color": "#6e6e6e"
        }
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: 60,
        containLabel: true,
      },
      toolbox: {
        feature: {
          magicType: {
            show: true,
            title: '',
            type: ["line", "bar", 'pie']
          },
          restore: {
            show: false
          },
          saveAsImage: {
            show: true,
            title: 'Save'
          },
          right: "16px"
        }
      },
      xAxis: {
        type: 'category',
        data: [],
        boundaryGap: false,
      },
      yAxis: [{
        type: 'value',
        name: "Unique users",
        nameLocation: "middle",
        nameGap: 40,
      }],
      series: [{
        name: 'Mobile',
        data: [],
        type: 'line',
        smooth: true,
      },
      {
        name: 'Web',
        data: [],
        type: 'line',
        smooth: true,
      },
      {
        name: 'API',
        data: [],
        type: 'line',
        smooth: true,
      },
      {
        name: 'Total',
        data: [],
        type: 'line',
        smooth: true,
      }
      ]
    },

    DASHBOARD_USERLOGS_CHARTDATA: {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
        backgroundColor: '#c7cfd9',
        textStyle: {
          "color": "#000"
        }
      },
      legend: {
        data: ["Mobile", "Web", "API", "Total"],
        bottom: 10,
        textStyle: {
          "color": "#6e6e6e"
        }
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: 60,
        containLabel: true,
      },
      toolbox: {
        feature: {
          magicType: {
            show: true,
            title: '',
            type: ["line", "bar", 'pie']
          },
          restore: {
            show: false
          },
          saveAsImage: {
            show: true,
            title: 'Save'
          },
          right: "16px"
        }
      },
      xAxis: {
        type: 'category',
        data: [],
        boundaryGap: false,
      },
      yAxis: [{
        type: 'value',
        name: "Unique users",
        nameLocation: "middle",
        nameGap: 40,
      }],
      series: [{
        name: 'Mobile',
        data: [],
        type: 'line',
        smooth: true,
      },
      {
        name: 'Web',
        data: [],
        type: 'line',
        smooth: true,
      },
      {
        name: 'API',
        data: [],
        type: 'line',
        smooth: true,
      },
      {
        name: 'Total',
        data: [],
        type: 'line',
        smooth: true,
      }
      ]
    },

    TOTALUSERLOGSCHARTDATA: {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
        backgroundColor: '#c7cfd9',
        textStyle: {
          "color": "#000"
        }
      },
      legend: {
        data: ["Mobile", "Web", "API"],
        bottom: 10,
        textStyle: {
          "color": "#6e6e6e"
        }
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: 60,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: [],
        boundaryGap: false,
      },
      yAxis: {
        type: 'value',
        name: "Total users",
        nameLocation: "middle",
        nameGap: 50,
      },
      series: [{
        name: 'Mobile',
        data: [],
        type: 'line',
        smooth: true,
      },
      {
        name: 'Web',
        data: [],
        type: 'line',
        smooth: true,
      },
      {
        name: 'API',
        data: [],
        type: 'line',
        smooth: true
      }
      ]
    },
    searchData: [],
    ipoData: [],
    sgbData: [],
    totalServiceHitCount: null,
    topViewsLoader: false,
    usersLoader: false,
  },

  mutations: {
    SET_LOGINDETAILS(state, payload) {
      state.loginDetails = payload;
    },
    SET_USERLOGINDETAILS(state, payload) {
      state.userLoginDetails = payload;
      state.userLoginDetailsWithoutWeekends = []
      var is_weekend = function (date1) {
        var dt = new Date(date1);
        if (dt.getDay() == 6 || dt.getDay() == 0) {
          return "weekend"
        } else {
          return 'day'
        }
      }
      payload.forEach(el => {
        if (is_weekend(el.date) == 'day') state.userLoginDetailsWithoutWeekends.push(el)
      })
      this.commit('SET_USERLOGSCHARTDATA', state.userLoginDetailsWithoutWeekends)
      this.commit('SET_DASHBOARD_USERLOGS_CHARTDATA', state.userLoginDetails)
    },
    SET_LOADER(state, payload) {
      state.loader = payload;
    },
    SET_USERBASEDLOGS(state, payload) {
      state.userBasedLogs = payload;
    },
    SET_URLBASEDLOGS(state, payload) {
      state.urlBasedLogs = payload;
    },
    SET_USERLOGSCHARTDATA(state, payload) {
      // Unique users
      state.USERLOGSCHARTDATA.xAxis.data = []
      state.USERLOGSCHARTDATA.series[0].data = []
      state.USERLOGSCHARTDATA.series[1].data = []
      state.USERLOGSCHARTDATA.series[2].data = []
      state.USERLOGSCHARTDATA.series[3].data = []
      // total users
      state.TOTALUSERLOGSCHARTDATA.xAxis.data = []
      state.TOTALUSERLOGSCHARTDATA.series[0].data = []
      state.TOTALUSERLOGSCHARTDATA.series[1].data = []
      state.TOTALUSERLOGSCHARTDATA.series[2].data = []

      payload.forEach(element => {
        // unique users
        state.USERLOGSCHARTDATA.xAxis.data.push(commonFunc.methods.getDateString(new Date(element.date), "d-M-y"));
        state.USERLOGSCHARTDATA.series[0].data.push(element.uniqueMobileLogin);
        state.USERLOGSCHARTDATA.series[1].data.push(element.uniqueWebLogin);
        state.USERLOGSCHARTDATA.series[2].data.push(element.uniqueApiLogin);
        state.USERLOGSCHARTDATA.series[3].data.push(element.totalLogin);
        // total users
        state.TOTALUSERLOGSCHARTDATA.xAxis.data.push(commonFunc.methods.getDateString(new Date(element.date), "d-M-y"));
        state.TOTALUSERLOGSCHARTDATA.series[0].data.push(element.totalMobileLogin);
        state.TOTALUSERLOGSCHARTDATA.series[1].data.push(element.totalWebLogin);
        state.TOTALUSERLOGSCHARTDATA.series[2].data.push(element.totalApiLogin);


      })
      state.TOTALUSERLOGSCHARTDATA.xAxis.data.reverse()
      state.TOTALUSERLOGSCHARTDATA.series[0].data.reverse()
      state.TOTALUSERLOGSCHARTDATA.series[1].data.reverse()
      state.TOTALUSERLOGSCHARTDATA.series[2].data.reverse()
      state.USERLOGSCHARTDATA.xAxis.data.reverse()
      state.USERLOGSCHARTDATA.series[0].data.reverse()
      state.USERLOGSCHARTDATA.series[1].data.reverse()
      state.USERLOGSCHARTDATA.series[2].data.reverse()
      state.USERLOGSCHARTDATA.series[3].data.reverse()
    },
    SET_DASHBOARD_USERLOGS_CHARTDATA(state, payload) {
      state.DASHBOARD_USERLOGS_CHARTDATA.xAxis.data = []
      state.DASHBOARD_USERLOGS_CHARTDATA.series[0].data = []
      state.DASHBOARD_USERLOGS_CHARTDATA.series[1].data = []
      state.DASHBOARD_USERLOGS_CHARTDATA.series[2].data = []
      state.DASHBOARD_USERLOGS_CHARTDATA.series[3].data = []
      payload.forEach(element => {
        state.DASHBOARD_USERLOGS_CHARTDATA.xAxis.data.push(commonFunc.methods.getDateString(new Date(element.date), "d-M-y"));
        state.DASHBOARD_USERLOGS_CHARTDATA.series[0].data.push(element.uniqueMobileLogin);
        state.DASHBOARD_USERLOGS_CHARTDATA.series[1].data.push(element.uniqueWebLogin);
        state.DASHBOARD_USERLOGS_CHARTDATA.series[2].data.push(element.uniqueApiLogin);
        state.DASHBOARD_USERLOGS_CHARTDATA.series[3].data.push(element.totalLogin);
      })
      state.DASHBOARD_USERLOGS_CHARTDATA.xAxis.data.reverse()
      state.DASHBOARD_USERLOGS_CHARTDATA.series[0].data.reverse();
      state.DASHBOARD_USERLOGS_CHARTDATA.series[1].data.reverse();
      state.DASHBOARD_USERLOGS_CHARTDATA.series[2].data.reverse();
      state.DASHBOARD_USERLOGS_CHARTDATA.series[3].data.reverse();

    },
    SET_SNAKBAR(state, payload) {
      state.snackbar.msg = payload.msg;
      state.snackbar.show = payload.show;
      state.snackbar.color = payload.color;
      state.snackbar.timeout = payload.timeout;
    },
    SET_MOBILEVIEW(state, payload) {
      state.isMobileView = payload
    },
    SET_HOLIDAYS(state, payload) {
      state.holidays = payload
    },

    SET_CANONICAL(state, payload) {
      const canonicalUrl = `${location.origin}${payload}`;
      const head = document.getElementsByTagName('head')[0];
      var element = document.querySelector(`link[rel='canonical']`) || null;
      if (element == null) {
        element = document.createElement('link');
        head.appendChild(element);
      }
      element.setAttribute('rel', 'canonical');
      element.setAttribute('href', canonicalUrl);
    },
    SET_SEARCH(state, payload) {
      state.search = payload
    },
    SET_SEARCH_DATA(state, payload) {
      state.searchData = payload
    },
    SET_IPO_DATA(state, payload) {
      state.ipoData = payload
    },
    SET_SGB_DATA(state, payload) {
      state.sgbData = payload
    },
    SET_TOTAL_SERVICE_HIT_COUNT(state, payload) {
      state.totalServiceHitCount = payload.reduce((accumulator, object) => {
        return accumulator + parseInt(object.count);
      }, 0);
    },
    SET_TOP_VIEWS_LOADER(state, payload) {
      state.topViewsLoader = payload
    },
    SET_USERS_LOADER(state, payload) {
      state.usersLoader = payload
    }
  },

  actions: {
    async adminLogin({ commit }, payload) {
      try {
        commit('SET_LOADER', true);
        let json = {
          "adminEmail": payload.userName,
          "adminPassword": payload.password
        }
        await service.adminLogin(json).then(response => {
          if (response.status == 200 && response.data.message == 'login Sucessfull') {
            if (response.data.result) {
              localStorage.setItem('userId', response.data.result.adminName)
              localStorage.setItem('sessionId', response.data.result.userSessionId)
              commit('SET_LOGINDETAILS', response.data.result)
              router.push('/dashboard')
            }
          } else {
            commit('SET_SNAKBAR', {
              msg: response.data.message,
              show: true,
              color: 'red lighten-1',
              timeout: 2500
            })
          }
        }).finally(() => {
          commit('SET_LOADER', false)
        })
      } catch (error) {
        commit('SET_LOADER', false)
        commit('SET_SNAKBAR', {
          msg: error,
          show: true,
          color: 'red lighten-1',
          timeout: 2500
        })
      }
    },
    async getUserLogDetails({ commit }, payload) {
      try {
        commit('SET_USERS_LOADER', true)
        await service.getUserLogDetails().then(response => {
          if (response.status == 200 && response.data.stat == 'Ok') {
            if (response.data.result) {
              commit('SET_USERLOGINDETAILS', response.data.result)
            }
          } else {
            commit('SET_USERLOGINDETAILS', [])
          }
        }).finally(() => {
          commit('SET_USERS_LOADER', false)
        })
      }
      catch (error) {
        commit('SET_SNAKBAR', {
          msg: error,
          show: true,
          color: 'red lighten-1',
          timeout: 2500
        })
      }
    },

    async getUserBasedRecords({ commit }) {
      try {
        commit('SET_LOADER', true);
        await service.getUserBasedRecords().then(response => {
          if (response.status == 200 && response.data.stat == 'Ok') {
            if (response.data.result) {
              commit('SET_USERBASEDLOGS', response.data.result)
            } else {
              commit('SET_USERBASEDLOGS', [])
            }
          }
        }).finally(() => {
          commit('SET_LOADER', false)
        })
      } catch (error) {
        commit('SET_SNAKBAR', {
          msg: error,
          show: true,
          color: 'red lighten-1',
          timeout: 2500
        })
      }
    },

    async getUrlBasedRecords({ commit }, payload) {
      try {
        commit('SET_TOP_VIEWS_LOADER', true);
        // commit('SET_LOADER', true);
        await service.getUrlBasedRecords(payload).then(response => {
          if (response.status == 200 && response.data.stat == 'Ok') {
            if (response.data.result)
              commit('SET_URLBASEDLOGS', response.data.result)
            commit('SET_TOTAL_SERVICE_HIT_COUNT', response.data.result)
          } else {
            commit('SET_URLBASEDLOGS', [])
          }
        }).finally(() => {
          // commit('SET_LOADER', false)
          commit('SET_TOP_VIEWS_LOADER', false);
        })
      } catch (error) {
        commit('SET_TOP_VIEWS_LOADER', false);
      }
    },

    async getHolidays({
      commit
    }) {
      commit('SET_LOADER', true);
      await service.getHolidays().then(response => {
        if (response.status == 200) {
          if (response.data.result)
            commit('SET_HOLIDAYS', response.data.result)
        }
      }).finally(() => {
        commit('SET_LOADER', false)
      })
    },

    async getSearchData({
      commit
    }, payload) {
      commit('SET_LOADER', true);
      await service.getSearchData(payload).then(response => {
        if (response.status == 200) {
          commit('SET_SEARCH_DATA', response.data)
        } else commit('SET_SEARCH_DATA', [])
      }).finally(() => {
        commit('SET_LOADER', false)
      })
    },
    async getIpo({
      commit
    }) {
      commit('SET_LOADER', true);
      await service.getIpo().then(response => {
        if (response.status == 200) {
          if (response.data.result)
            commit('SET_IPO_DATA', response.data.result)
          else
            commit('SET_IPO_DATA', [])
        }
      }).finally(() => {
        commit('SET_LOADER', false)
      })
    },
    async getSgb({
      commit
    }) {
      commit('SET_LOADER', true);
      await service.getSgb().then(response => {
        if (response.status == 200) {

          if (response.data.result)
            commit('SET_SGB_DATA', response.data.result)
          else
            commit('SET_SGB_DATA', [])
        }
      }).finally(() => {
        commit('SET_LOADER', false)
      })
    },
    async schedulerOnOff({
      commit
    }, payload) {
      commit('SET_LOADER', true);
      try {
        service.schedulerOnOff(payload).then(response => {
          if (response.status == 200) {
            commit('SET_SNAKBAR', {
              msg: response.data,
              show: true,
              color: 'teal darken-1',
              timeout: 2500
            })
          } else commit('SET_SNAKBAR', {
            msg: response.data,
            show: true,
            color: 'red',
            timeout: 2500
          })
        }).finally(() => {
          commit('SET_LOADER', false)
        })
      } catch (error) {
        commit('SET_LOADER', false)
        commit('SET_SNAKBAR', {
          msg: error,
          show: true,
          color: 'red',
          timeout: 2500
        })
      }
    },
  },

  getters: {
    getBrokerName: state => {
      return state.brokerName
    },
    getUserLoginDetails: state => {
      return state.userLoginDetails
    },
    getUserLoginDetailsWithoutWeekends: state => {
      return state.userLoginDetailsWithoutWeekends
    },
    getLoader: state => {
      return state.loader
    },
    getUserBasedLogs: state => {
      return state.userBasedLogs
    },
    getUrlBasedLogs: state => {
      return state.urlBasedLogs
    },
    GETUSERLOGSCHARTDATA: state => {
      return state.USERLOGSCHARTDATA
    },
    GET_DASHBOARD_USERLOGS_CHARTDATA: state => state.DASHBOARD_USERLOGS_CHARTDATA,
    GETTOTALUSERLOGSCHARTDATA: state => {
      return state.TOTALUSERLOGSCHARTDATA
    },
    getSnackbar: state => {
      return state.snackbar
    },
    getIsMobileView: state => {
      return state.isMobileView
    },
    getHolidays: state => {
      return state.holidays
    },
    getSearch: state => {
      return state.search
    },
    getSearchData: state => {
      return state.searchData
    },
    getIpoData: state => {
      return state.ipoData
    },
    getSgbData: state => {
      return state.sgbData
    },
    getTotalServiceHitCount: state => state.totalServiceHitCount,
    getTopViewsLoader: state => state.topViewsLoader,
    getUsersLoader: state => state.usersLoader,
  },

  modules: {
    orderCount,
    scripInfo,
    cMaster,
    uploadFile,
    sector,
    event,
    result,
    news,
    logs,
    apiKey,
    mpin,
    payment,
    edisdata,
    query,
    mostActive,
    orderWindow,
    auth,
    adminMessage,
    bankdetails,
    mobileVersion
  }
})